export default {
  'umall/business/consumer/maparea/searchAreaAndDistrict': true,
  'umall/business/consumer/maparea/pcSearch': true,
  'umall/business/consumer/businessInfo/queryPcBusiness': true,
}